
import { MaterialController } from "./controllers/materialController";
import '../packageDetail/packageDetailDirective';

export class MaterialDirective implements angular.IDirective {
    template = require('./templates/material.html');
    restrict = 'E';
    controller = MaterialController;
    controllerAs = 'vm';
    bindToController = {
        requestDetail: '=requestDetail',
        requestMaterial:'=requestMaterial'
    };
    scope = {};

    static factory(): angular.IDirectiveFactory {
        return () => new MaterialDirective();
    }
}

angular.module('deliveryCreate.app').directive("material", MaterialDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/directives/materials/materialDirective.ts
 **/